import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  addScorecard: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.SchedulerStage.ScorecardCard.AddScorecardModal.addScorecard`,
    defaultMessage: 'Add scorecard',
  },
  scorecard: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.SchedulerStage.ScorecardCard.AddScorecardModal.scorecard`,
    defaultMessage: 'Scorecard',
  },
  scorecardPlaceholder: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.SchedulerStage.ScorecardCard.AddScorecardModal.scorecardPlaceholder`,
    defaultMessage: 'Please select...',
  },
  assigneeNote: {
    id: `app.containers.WorkflowEditor.components.WorkflowEditorContent.StageDetail.SchedulerStage.ScorecardCard.AddScorecardModal.assigneeNote`,
    defaultMessage: 'This scorecard will be assigned to the hiring manager.',
  },
});
